<script setup lang="ts">
import { categories } from '~/components/widget/faq-page/filter/mocks'
import { WidgetFaqPageSearchInput } from '~/components/widget/faq-page'

const props = defineProps<{
  selectedCategories: string[]
  searchQuery: string
}>()

const emit = defineEmits<{
  (e: 'update:selectedCategories', value: string[]): void
  (e: 'update:searchQuery', value: string): void
}>()

const updateSearchQuery = (value: string) => {
  emit('update:searchQuery', value)
}

const updateSelectedCategories = (value: string[]) => {
  emit('update:selectedCategories', value)
}
</script>

<template>
  <div>
    <Heading tag="h2" class="mb-2 font-bold !leading-6 md:text-center md:!text-4xl md:!leading-9">{{
      $t('widget.faq_page.title')
    }}</Heading>
    <p class="text-sm leading-5 md:mb-6 md:text-center md:leading-6">
      {{ $t('widget.faq_page.description') }}
    </p>
    <template v-if="!$device.isMobile">
      <div class="mb-5">
        <WidgetFaqPageSearchInput
          :model-value="props.searchQuery"
          @update:model-value="updateSearchQuery"
        />
      </div>
      <div class="flex flex-wrap gap-3">
        <div v-for="category in categories" :key="category.value" class="inline-flex items-center">
          <input
            :id="category.value"
            :checked="props.selectedCategories.includes(category.value)"
            type="checkbox"
            :value="category.value"
            class="peer hidden"
            @change="
              updateSelectedCategories(
                props.selectedCategories.includes(category.value)
                  ? props.selectedCategories.filter((c) => c !== category.value)
                  : [...props.selectedCategories, category.value]
              )
            "
          />
          <label
            :for="category.value"
            class="FilterLabel bg-gray-100 px-3 py-2 text-sm"
          >
            <component :is="category.icon" v-if="category.icon" class="mr-2 h-6 w-6" />
            {{ $t(category.label) }}
          </label>
        </div>
      </div>
    </template>
  </div>
</template>
